import type { FC } from 'react';
import { Link } from 'react-router-dom';

const HeroSection: FC = () => {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20bedroom%20interior%20with%20soft%20ambient%20lighting%2C%20foggy%20window%20with%20rain%2C%20cream%20colored%20bedding%2C%20aromatherapy%20diffuser%2C%20headphones%20on%20wooden%20nightstand%2C%20warm%20amber%20and%20beige%20tones%2C%20minimalist%20composition%2C%20calm%20and%20peaceful%20atmosphere%2C%20dreamy%20soft%20focus%2C%20editorial%20interior%20photography&width=1920&height=1080&seq=hero-asmr-01&orientation=landscape"
          alt="ASMR基佬中心 - 放松助眠的温馨空间"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 bg-background-50/15 backdrop-blur-sm rounded-full text-sm text-background-50 border border-background-50/20 whitespace-nowrap">
            <i className="ri-sparkling-line mr-1.5"></i>专注ASMR内容聚合
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          探索属于你的<br className="hidden sm:block" />
          <span className="text-accent-300">ASMR声音世界</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          ASMR基佬中心汇聚海量ASMR音频视频资源，提供放松助眠、情感陪伴类ASMR内容，满足不同用户的个性化需求，立即探索属于你的ASMR世界。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/shuimian-fangsong"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始探索 <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;